/**
 * Mobile Safety landing. Quick-action tiles for on-site staff:
 * Raise Observation, Report Near-Miss, Toolbox Talk, PPE Check.
 *
 * Mobile_Safety_Quality_And_Nav_Cleanup (16-Sep-2026): Quality tiles moved out
 * to their own MobileQualityHome.jsx + dedicated bottom-nav icon — this page
 * is Safety-only now.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldAlert, AlertTriangle, Users, HardHat, ShieldCheck } from 'lucide-react';

const TILES = [
  { to: '/m/safety/observation', icon: ShieldAlert, title: 'Raise Observation', desc: 'Unsafe act / condition' },
  { to: '/m/safety/near-miss', icon: AlertTriangle, title: 'Report Near-Miss', desc: 'Could have caused harm' },
  { to: '/m/safety/toolbox', icon: Users, title: 'Toolbox Talk', desc: 'Pre-work safety briefing' },
  { to: '/m/safety/ppe', icon: HardHat, title: 'PPE Check', desc: 'Spot-check protective gear' },
];

export default function MobileSafetyHome() {
  return (
    <div className="px-5 pt-5 pb-6" data-testid="m-safety-home">
      <header className="mb-5 bg-gradient-to-br from-[#b91c1c] to-[#7f1d1d] text-white rounded-2xl p-5 shadow-lg">
        <div className="text-[10px] uppercase tracking-[0.22em] text-white/70 font-display font-bold flex items-center gap-1.5">
          <ShieldCheck size={11} /> Safety / HSE
        </div>
        <h1 className="font-display font-bold text-2xl text-white mt-1 leading-tight">Report it now</h1>
        <p className="text-[11px] text-white/70 mt-1">A safety report is most useful in the moment, on-site.</p>
      </header>

      <div className="grid grid-cols-2 gap-3">
        {TILES.map((t) => (
          <Link
            key={t.to}
            to={t.to}
            data-testid={`m-safety-tile-${t.title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
            className="group bg-white border border-slate-200 hover:border-[#b91c1c]/50 rounded-2xl p-4 flex flex-col gap-3 active:scale-[0.97] transition-all shadow-sm hover:shadow-md min-h-[124px]"
          >
            <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#b91c1c] to-[#7f1d1d] text-white flex items-center justify-center shrink-0">
              <t.icon size={20} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-display font-bold text-[15px] text-slate-900 leading-tight">{t.title}</div>
              <div className="text-[11px] text-slate-500 mt-1 leading-snug">{t.desc}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
